export const NOTIFICATION_TEMPLATES = {
  studentAdded: {
    title: "New Student Added",
    description: "A new student has been added to the system",
    type: "info",
    priority: "medium"
  },
  staffAdded: {
    title: "New Staff Member Added",
    description: "A new staff member has been added to the system",
    type: "alert",
    priority: "high"
  },
  paymentReceived: {
    title: "Payment Received",
    description: "New payment has been processed",
    type: "success",
    priority: "medium"
  },
  eventScheduled: {
    title: "New Event Scheduled",
    description: "A new event has been added to the calendar",
    type: "info",
    priority: "low"
  },
  error: {
    title: "Error",
    description: "An error has occurred",
    type: "warning",
    priority: "high"
  }
};

export const NOTIFICATION_TYPE_MAP = {
  'payment': 'success',
  'enrollment': 'info',
  'academic': 'info',
  'library': 'info',
  'sports': 'info',
  'schedule': 'info',
  'error': 'warning'
};